'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _WebformUtils = require('../WebformUtils');

var _WebformUtils2 = _interopRequireDefault(_WebformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Number = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Number, _Component);
  (0, _createClass3.default)(Number, null, [{
    key: 'validate',


    /**
     * @param {Field} field Field
     */
    value: function validate(field) {
      var numberError = _WebformUtils2.default.getCustomValue(field.element, 'numberError', field.formStore.form.settings);

      if (field.element['#step']) {
        var dec = Math.max.apply(Math, (0, _toConsumableArray3.default)([field.element['#step'], field.value].map(function (n) {
          return (n + '.').split('.')[1].length;
        })));
        if (Math.round(field.value * Math.pow(10, dec)) % Math.round(field.element['#step'] * Math.pow(10, dec)) !== 0) {
          return [numberError];
        }
      }

      if (field.element['#min'] && parseFloat(field.value) < parseFloat(field.element['#min'])) {
        return [numberError];
      }

      if (field.element['#max'] && parseFloat(field.value) > parseFloat(field.element['#max'])) {
        return [numberError];
      }

      return [];
    }
  }]);

  function Number(props) {
    (0, _classCallCheck3.default)(this, Number);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Number.__proto__ || (0, _getPrototypeOf2.default)(Number)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Number, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Input2.default, (0, _extends3.default)({}, this.props, {
        type: 'number',
        onBlur: this.props.onBlur,
        onChange: this.onChange
      }));
    }
  }]);
  return Number;
}(_react.Component), _class2.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired
}, _temp)) || _class;

exports.default = Number;